const common = {
	tips:{
		down:'展开',
		up:'收起',
		more:'查看更多',
		noMore:'没有更多了',
		empty:'暂无数据'
	},
}

export default common